import React from 'react';
import { Target, Lightbulb, Users, ShieldCheck, Zap, Globe } from 'lucide-react';
import Button from '../components/Button';

const About = () => {
  return (
    <div className="pt-24 min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-navy/5">
        <div className="container-custom text-center">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-primary/10 border border-primary/20">
            <span className="text-primary font-semibold text-sm tracking-wide uppercase">Our Story</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy mb-6">
            Engineering Innovation.<br className="hidden md:block" />
            <span className="text-primary"> Digital Excellence. Business Transformation.</span>
          </h1>
          <p className="text-lg md:text-xl text-navy/70 max-w-3xl mx-auto leading-relaxed mb-8">
            Keel Info Solution is a technology and engineering partner helping businesses across industries innovate, scale and grow — combining enterprise-ready software with precision engineering to deliver real, measurable results.
          </p>
        </div>
      </section>

      {/* Stats Section */}
      {/* <section className="py-16 bg-white border-b border-navy/5">
        <div className="container-custom">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-navy/10">
            <div className="text-center">
              <h3 className="text-4xl md:text-5xl font-bold text-navy mb-2">150+</h3>
              <p className="text-navy/60 font-medium">Projects Delivered</p>
            </div>
            <div className="text-center">
              <h3 className="text-4xl md:text-5xl font-bold text-navy mb-2">50+</h3>
              <p className="text-navy/60 font-medium">Expert Engineers</p>
            </div>
            <div className="text-center">
              <h3 className="text-4xl md:text-5xl font-bold text-navy mb-2">12+</h3>
              <p className="text-navy/60 font-medium">Countries Served</p>
            </div>
            <div className="text-center">
              <h3 className="text-4xl md:text-5xl font-bold text-navy mb-2">99%</h3>
              <p className="text-navy/60 font-medium">Client Retention</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Mission & Vision */}
      <section className="py-24 bg-white">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="absolute inset-0 bg-primary/5 rounded-3xl transform rotate-3 scale-105"></div>
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Team collaborating" className="relative rounded-3xl shadow-xl z-10" />
            </div>
            <div>
              <div className="mb-12">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
                    <Target size={24} />
                  </div>
                  <h2 className="text-3xl font-bold text-navy">Our Mission</h2>
                </div>
                <p className="text-navy/70 text-lg leading-relaxed">
                  Our mission is to deliver reliable, innovative and cost-effective technology and engineering solutions that help businesses improve operations, accelerate growth and achieve long-term success through strong partnerships and technical excellence.
                </p>
              </div>

              <div>
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-accent-teal/10 flex items-center justify-center text-accent-teal">
                    <Lightbulb size={24} />
                  </div>
                  <h2 className="text-3xl font-bold text-navy">Our Vision</h2>
                </div>
                <p className="text-navy/70 text-lg leading-relaxed">
                  To become a trusted global technology and engineering partner, empowering organizations to innovate, scale and succeed through intelligent, reliable and future-ready solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-24 bg-navy/5">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4">Our Core Values</h2>
            <p className="text-navy/70 max-w-2xl mx-auto text-lg">Everything we build is guided by a consistent set of values — ensuring every engagement, regardless of scale or industry, meets the same standard of quality and trust.</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: ShieldCheck, title: "Quality", desc: "Delivering rigorously tested, reliable solutions in every engagement", color: "text-primary" },
              { icon: Users, title: "Team Work", desc: "Collaborating closely with clients and across teams to achieve shared success.", color: "text-accent-teal" },
              { icon: Zap, title: "Integrity", desc: "Building every partnership on transparency, honesty and accountability.", color: "text-accent-purple" },
              { icon: Globe, title: "Innovation", desc: "Continuously exploring new technologies and approaches to solve business challenges.", color: "text-primary" }
            ].map((value, index) => (
              <div key={index} className="bg-white p-8 rounded-2xl shadow-lg shadow-navy/5 border border-navy/5 hover:-translate-y-1 transition-transform">
                <value.icon className={`w-10 h-10 ${value.color} mb-6`} />
                <h3 className="text-xl font-bold text-navy mb-3">{value.title}</h3>
                <p className="text-navy/60 leading-relaxed">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
